var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"index-shards-tab-content\">\n<table class=\"table table-condensed table-hover\" ts-wrapper ts-per-page-default=\"10\">\n<thead>\n<tr>\n<th ts-criteria=\"shard\">Shard</th>\n<th ts-criteria=\"state\">State</th>\n<th ts-criteria=\"docs\"># Docs</th>\n<th ts-criteria=\"store\">Size</th>\n<th ts-criteria=\"prirep\">Primary</th>\n<th ts-criteria=\"node\">Node</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shard in iSTabContentCtrl.shards\" ts-repeat ts-hide-no-data>\n<td>{{shard.shard}}</td>\n<td>{{shard.state}}</td>\n<td>{{shard.docs | numeral: '0[.][0] a'}}</td>\n<td>{{shard.store}}</td>\n<td>{{shard.prirep === 'p'}}</td>\n<td>{{shard.node}}</td>\n</tr>\n</tbody>\n</table>\n</div>";
var id1="components/index-shards-tab-content/index-shards-tab-content.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/index-shards-tab-content/index-shards-tab-content.template.html
// module id = 902
// module chunks = 0